import { autoinject, bindable, containerless } from 'aurelia-framework';
import { ValidationController, Validator } from 'aurelia-validation';
import { PropertyBindError } from 'lib/error';
import { Locale, languages } from 'services/language-service';

@autoinject
@containerless
export class LocaleSelect {
  @bindable
  public onLocaleChanged: (locale: Locale) => void;

  @bindable
  public locale: Locale = 'nb-NO';

  @bindable
  public disabled: boolean;

  @bindable
  name: string;

  @bindable
  validationController: ValidationController;

  @bindable
  propertyName: string;

  @bindable
  label: string = 'general.language';

  public locales = languages.map((lang) => {
    return { Id: lang.Id, Name: lang.Name };
  });

  constructor(protected validator: Validator) {}

  attached() {
    if (!this.onLocaleChanged) {
      throw new PropertyBindError({ property: 'onLocaleChanged' });
    }

    if (!this.validationController) {
      throw new PropertyBindError({ property: 'validationController' });
    }

    if (!this.name) {
      throw new PropertyBindError({ property: 'name' });
    }

    if (!this.propertyName) {
      throw new PropertyBindError({ property: 'propertyName' });
    }
  }
}
